export const GIFT_OPTIONS = Object.freeze({
  GIFTING: 'gifting',
  CHARITIES: 'charities',
  CROWDFUNDING: 'crowdfunding',
  PHOTOS: 'photo-sharing',
  HOST_PHOTO_GALLERY: 'host-photo-gallery',
  POLLS: 'polls',
  WHAT_TO_BRING: 'whatToBring',
  ADS: 'ads',
});
